import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// actions
import { InfluencerApiResponseSuccess, InfluencerApiResponseError, getInfluencer } from "./actions";

// constants
import { InfluencerActionTypes } from "./constants";
import {
  addInfluencerApi,
  deleteInfluencerApi,
  getInfluencerApi,
  getInfluencerCommisionsReportsApi,
  getInfluencerCouponsReportsApi,
  updateInfluencerApi,
  updateInfluencerPasswordApi,
} from "../../helpers/api/influencer";

interface InfluencerData {
  payload: {
    id: string;
    name: string;
    phone: string;
    email: string;
    password: string;
    coupon: number | string;
  };
  type: string;
}

function* createInfluencer({ payload: { name, phone, email, password } }: InfluencerData): SagaIterator {
  try {
    const response = yield call(addInfluencerApi, {
      name,
      phone,
      email,
      password,
    });

    const InfluencerData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(InfluencerApiResponseSuccess(InfluencerActionTypes.CREATE_INFLUENCER, InfluencerData));
    yield put(getInfluencer());
  } catch (error: any) {
    

    yield put(InfluencerApiResponseError(InfluencerActionTypes.CREATE_INFLUENCER, error));
  }
}

function* upadateInfluencerPassword({ payload: { email } }: InfluencerData): SagaIterator {
  try {
    const response = yield call(updateInfluencerPasswordApi, email);

    const InfluencerData = response.data.message;

    yield put(InfluencerApiResponseSuccess(InfluencerActionTypes.UPDATE_INFLUENCER_PASSWORD, InfluencerData));
    yield put(getInfluencer());
  } catch (error: any) {
    yield put(InfluencerApiResponseError(InfluencerActionTypes.UPDATE_INFLUENCER_PASSWORD, error));
  }
}

function* updateInfluencer({ payload: { id, name, phone, email } }: InfluencerData): SagaIterator {
  try {
    const response = yield call(updateInfluencerApi, {
      id,
      name,
      phone,
      email,
    });
    const InfluencerData = response.data.message;

    yield put(InfluencerApiResponseSuccess(InfluencerActionTypes.UPDATE_INFLUENCER, InfluencerData));
    yield put(getInfluencer());
  } catch (error: any) {
    yield put(InfluencerApiResponseError(InfluencerActionTypes.UPDATE_INFLUENCER, error));
  }
}

function* getCategories(): SagaIterator {
  try {
    const response = yield call(getInfluencerApi);
    const InfluencerData = response?.data;

    yield put(InfluencerApiResponseSuccess(InfluencerActionTypes.GET_INFLUENCER, InfluencerData));
  } catch (error: any) {
    yield put(InfluencerApiResponseError(InfluencerActionTypes.GET_INFLUENCER, error));
  }
}

function* deleteInfluencer({ payload: { id } }: InfluencerData): SagaIterator {
  try {
    const response = yield call(deleteInfluencerApi, id);
    const InfluencerData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(InfluencerApiResponseSuccess(InfluencerActionTypes.DELETE_INFLUENCER, InfluencerData));
    yield put(getInfluencer());
  } catch (error: any) {
    yield put(InfluencerApiResponseError(InfluencerActionTypes.DELETE_INFLUENCER, error));
  }
}

function* getInfluencerCouponReports(): SagaIterator {
  try {
    const response = yield call(getInfluencerCouponsReportsApi);
    const CouponsData = response?.data;

    yield put(InfluencerApiResponseSuccess(InfluencerActionTypes.GET_COUPON_REPORTS, CouponsData));
  } catch (error: any) {
    yield put(InfluencerApiResponseError(InfluencerActionTypes.GET_COUPON_REPORTS, error));
  }
}

function* getInfluencerCommisionReports({ payload: { from, to, coupon } }: any): SagaIterator {
  try {
    const response = yield call(getInfluencerCommisionsReportsApi, coupon, from, to);
    const CouponsData = response?.data;

    yield put(InfluencerApiResponseSuccess(InfluencerActionTypes.GET_COMMISION_REPORTS, CouponsData));
  } catch (error: any) {
    yield put(InfluencerApiResponseError(InfluencerActionTypes.GET_COMMISION_REPORTS, error));
  }
}

export function* watchCreateInfluencer() {
  yield takeEvery(InfluencerActionTypes.CREATE_INFLUENCER, createInfluencer);
}
export function* watchUpdateInfluencer() {
  yield takeEvery(InfluencerActionTypes.UPDATE_INFLUENCER, updateInfluencer);
}
export function* watchGetInfluencer() {
  yield takeEvery(InfluencerActionTypes.GET_INFLUENCER, getCategories);
}

export function* watchDeleteInfluencer() {
  yield takeEvery(InfluencerActionTypes.DELETE_INFLUENCER, deleteInfluencer);
}

export function* watchGetCouponReports() {
  yield takeEvery(InfluencerActionTypes.GET_COUPON_REPORTS, getInfluencerCouponReports);
}

export function* watchGetCommisionReports() {
  yield takeEvery(InfluencerActionTypes.GET_COMMISION_REPORTS, getInfluencerCommisionReports);
}

export function* watchGetUpdateInfluencerPassword() {
  yield takeEvery(InfluencerActionTypes.UPDATE_INFLUENCER_PASSWORD, upadateInfluencerPassword);
}

function* InfluencerSaga() {
  yield all([
    fork(watchGetCouponReports),
    fork(watchCreateInfluencer),
    fork(watchUpdateInfluencer),
    fork(watchDeleteInfluencer),
    fork(watchGetInfluencer),
    fork(watchGetUpdateInfluencerPassword),
    fork(watchGetCommisionReports),
  ]);
}

export default InfluencerSaga;
